import { useEffect } from 'react'
import { LoginStep, useAuthentication } from '@heidelbergmaterials/fcl-authclient'
import { ShellAuthenticated } from './shells/ShellAuthenticated'
import { ShellUnauthenticated } from './shells/ShellUnauthenticated'
import { ShellInAuthenticationFlow } from './shells/ShellInAuthenticationFlow'
import { ENV } from './settings'

export function App() {
  const { loginStep, startLoginFlow } = useAuthentication();

  // Dev-only: skip the Entra sign-in entirely. Guarded by import.meta.env.DEV so a
  // production build can NEVER render the authenticated shell without logging in —
  // the branch is dead-code-eliminated from prod bundles.
  const devSkipAuth = import.meta.env.DEV && !ENV.auth_enabled;

  useEffect(() => {
    if (devSkipAuth) return;
    void startLoginFlow();
  // startLoginFlow is a new ref each render — safe to call only on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (devSkipAuth) {
    return <ShellAuthenticated />;
  }

  switch (loginStep) {
    case LoginStep.Authenticated:
      return <ShellAuthenticated />;
    case LoginStep.Unauthenticated:
      return <ShellUnauthenticated />;
    default:
      return <ShellInAuthenticationFlow />;
  }
}

export default App